module.exports = __webpack_public_path__ + "static/media/kaed.fd23d960.jpg";